import React, { useEffect } from "react";

import Tooltip from "@mui/material/Tooltip";
import Box from "@mui/material/Box";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useClipboard } from "../../hooks";

function PastFromClipboard({ setTarget }) {
    const { past, clipboard } = useClipboard();
    const handlePast = () => {
        past();
    };
    useEffect(() => {
        if (clipboard) {
            setTarget(clipboard);
        }
    }, [clipboard]);

    return (
        <Tooltip disableInteractive title="Past from the clipboard">
            <Box component="span" sx={{ verticalAlign: "bottom" }}>
                <ContentCopyIcon
                    sx={{
                        marginLeft: "1rem",
                        cursor: "copy",
                    }}
                    onClick={handlePast}
                />
            </Box>
        </Tooltip>
    );
}

export default PastFromClipboard;
